import { getInspectorContracts, getProveedores } from '../../../services/adminContracts';
import {
  getAprooverContractsV1,
  getProvidersForAprooverV1,
  getRequestServices,
  getUbicationByUbicationType
} from '../../../services/serviceRequest';
import {
  getImputationsObjects,
  getUbicationsOyM,
  getWellEventDate
} from '../../../services/yclickMaster';
import { ubicationTypeEnum } from '../../../utils/dataStatus';

// Body formatters

// Fetch providers:
const bodyMakerToGetProviders = (value, contratosIds) => ({
  numerosContratos: contratosIds?.length
    ? contratosIds?.map((contrato) => Number(contrato?.nombre))
    : [],
  nombreProveedor: value
});

// Fetch Contracts:
const bodyMakerToGetContracts = (value, idsProveedores) => ({
  numeroContrato: value,
  proveedoresIds: idsProveedores?.length ? idsProveedores?.map((proveedor) => proveedor?.id) : []
});

// ------------------------------------------------------------>

export const fetchInspectorContracts = async (value, idsProveedores) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetContracts(value, idsProveedores);
  const { data } = await getInspectorContracts(body);

  return data;
};

export const fetchAprooverContracts = async (value, idsProveedores) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetContracts(value, idsProveedores);
  const { data } = await getAprooverContractsV1(body);

  return data;
};

export const fetchProveedores = async (value, contratosIds) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetProviders(value, contratosIds);
  const { data } = await getProveedores(body);

  return data;
};

export const fetchProvidersForAproover = async (value, contratosIds) => {
  if (value.length < 3) return null;
  const body = bodyMakerToGetProviders(value, contratosIds);
  const { data } = await getProvidersForAprooverV1(body);

  return data;
};

export const fetchLocations = async (value, tipoUbicacionId) => {
  if (value.length < 3) return null;
  let promise;

  if (tipoUbicacionId.id === ubicationTypeEnum.pozo) {
    promise = () => getUbicationByUbicationType({ value, typeUbication: tipoUbicacionId?.id });
  } else {
    promise = () =>
      getUbicationsOyM({
        tipoUbicacionId: tipoUbicacionId.id,
        operacionId: null,
        nombre: value
      });
  }

  const data = await promise();

  return data;
};

// Fetch Request Services
export const fetchRequestService = async (value) => {
  if (value.length < 4) return null;
  const data = await getRequestServices(value);

  const adapter = data.map((solicitud) => ({
    ...solicitud,
    nombre: solicitud.numero
  }));

  return adapter;
};

export const getWellEventDateAdapterFunction = async ({ idsEventos, fechaDesde, fechaHasta }) => {
  const body = {
    eventoIds: idsEventos.map((option) => option.id),
    fechaInicio: new Date(fechaDesde),
    fechaFin: new Date(fechaHasta)
  };

  const res = await getWellEventDate(body);

  return res.data;
};

// Fetch ObjectImputation
export const fetchObjectImputation = async (objectImputationType, value) => {
  if (value.length < 5) return null;
  const data = await getImputationsObjects(objectImputationType?.id, value);

  const adapter = data.map((obj) => ({
    id: obj.id,
    nombre: obj.codigo && obj.descripcion ? `${obj.codigo} | ${obj.descripcion}` : undefined
  }));

  return adapter;
};
